/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { Trophy, Smartphone, Crown, Star, Award } from "lucide-react";
import { API, BACKEND_URL, DESIGN_W, DESIGN_H, resolveUrl, devLog, devError, devDebug, useViz } from "./visualizerShared";

export const TwelvePointsOverlay = () => {
  const {
    audioUnlocked, setAudioUnlocked, leaderboard, setLeaderboard, currentVoter, setCurrentVoter,
    currentVote, setCurrentVote, showAnimation, setShowAnimation, countries, setCountries,
    voteApplied, setVoteApplied, backgroundVideo, setBackgroundVideo, fontTitle, setFontTitle,
    fontSubtitle, setFontSubtitle, fontCountry, setFontCountry, fontPoints, setFontPoints,
    fontVoting, setFontVoting, customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName,
    customFontSubtitleUrl, setCustomFontSubtitleUrl, customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl,
    customFontCountryName, setCustomFontCountryName, customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName,
    customFontVotingUrl, setCustomFontVotingUrl, customFontVotingName, setCustomFontVotingName, customFontsLoaded, setCustomFontsLoaded,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    logoUrl, setLogoUrl, logoPosition, setLogoPosition, logoSize, setLogoSize,
    logoZIndex, setLogoZIndex, logoOpacity, setLogoOpacity, extraImages, setExtraImages,
    fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle, fontSizeCountry, setFontSizeCountry,
    fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting, rowBgEven, setRowBgEven,
    rowBgOdd, setRowBgOdd, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, revealedVoters, setRevealedVoters, mystery12Text, setMystery12Text,
    twelveRevealed, setTwelveRevealed, voteDisplayColumns, setVoteDisplayColumns, showVoterBorder, setShowVoterBorder,
    showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary, customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl,
    customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled, overlay12DurationMode, setOverlay12DurationMode,
    overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle, overlay12BgColor, setOverlay12BgColor,
    overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives, overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12ArrowColor, overlay12ArrowThickness, overlay12ArrowHeadSize,
    overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle, overlay12FontCountry, setOverlay12FontCountry,
    overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale, overlay12Visible, setOverlay12Visible,
    overlay12RecipientId, setOverlay12RecipientId, overlay12Stage, setOverlay12Stage, winnerOverlayEnabled, setWinnerOverlayEnabled,
    winnerOverlayDurationMode, setWinnerOverlayDurationMode, winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle,
    winnerOverlayBgColor, setWinnerOverlayBgColor, winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText,
    winnerOverlaySubtitleText, setWinnerOverlaySubtitleText, winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti,
    winnerOverlayShowPoints, setWinnerOverlayShowPoints, winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle,
    winnerOverlayFontCountry, setWinnerOverlayFontCountry, winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale,
    winnerOverlayVisible, setWinnerOverlayVisible, winnerOverlayWinnerId, setWinnerOverlayWinnerId, winnerOverlayWinnerPoints, setWinnerOverlayWinnerPoints,
    allVotesApplied, setAllVotesApplied, orientation, setOrientation, showRotateHint, setShowRotateHint,
    videoRef, audioRef, sound12PointsUrlRef, confettiEnabledRef, confettiColorsRef, prevTwelveFromServerRef,
    prevOverlayVisibleRef, overlayAutoCloseTimerRef, overlayStageTimerRef, pollRef, fetchCurrentVoteRef, lastCountriesRef,
    lastBgConfigRef, lastRevealedRef, prevWinnerVisibleRef, winnerAutoCloseTimerRef, winnerConfettiIntervalRef, playVoterVideoWithSound,
    triggerTwelveRevealEffects, voterCountryId, voterShowAnimation, fetchLeaderboard, fetchCurrentVoter, fetchCountries,
    fetchBackground, fetchCurrentVote, fetchVotingStatus, fetchRevealedVoters, triggerWinnerConfetti, stopWinnerConfetti,
    fetchWinnerOverlay, computeDynamicSubtitle, getMedalClass, getTop3Color, getPositionalTranslucent, applyTranslucency,
    getMedalIcon, getPositionClass, half, leftColumn, rightColumn, getActiveFont,
  } = useViz();
  return (
      <AnimatePresence>
        {overlay12Visible && overlay12Enabled && (() => {
          const giverCountry = currentVoter ? countries.find(c => c.id === currentVoter.country_id) : null;
          const recipientCountry = overlay12RecipientId ? countries.find(c => c.id === overlay12RecipientId) : null;
          if (!recipientCountry) return null;

          // Custom style overrides
          const SCALE_MULT = { xs: 0.7, s: 0.85, m: 1, l: 1.2, xl: 1.5 };
          const k = overlay12StyleCustom ? (SCALE_MULT[overlay12SizeScale] || 1) : 1;
          const titleFont = overlay12StyleCustom ? overlay12FontTitle : fontTitle;
          const countryFont = overlay12StyleCustom ? overlay12FontCountry : fontCountry;
          const secondaryFont = overlay12StyleCustom ? overlay12FontSecondary : fontVoting;
          const ovFont = (v, section) => v === 'OverlayCustom' ? 'Overlay12CustomFont' : getActiveFont(v, section);

          const bgOpacityRatio = Math.max(0, Math.min(1, overlay12BgOpacity / 100));
          let bgStyle = {};
          if (overlay12BgStyle === "gradient") {
            const c1 = overlay12UseAdminColors ? primaryColor : "#EC4899";
            const c2 = overlay12UseAdminColors ? tertiaryColor : "#8B5CF6";
            const c3 = overlay12UseAdminColors ? secondaryColor : "#22D3EE";
            bgStyle = {
              background: `radial-gradient(ellipse at 30% 30%, ${c1}${Math.round(bgOpacityRatio * 153).toString(16).padStart(2,'0')} 0%, transparent 60%), radial-gradient(ellipse at 70% 70%, ${c3}${Math.round(bgOpacityRatio * 153).toString(16).padStart(2,'0')} 0%, transparent 60%), linear-gradient(135deg, ${c2}${Math.round(bgOpacityRatio * 230).toString(16).padStart(2,'0')} 0%, #000000${Math.round(bgOpacityRatio * 255).toString(16).padStart(2,'0')} 100%)`,
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)'
            };
          } else if (overlay12BgStyle === "solid") {
            const hex = overlay12BgColor.replace('#', '');
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            bgStyle = {
              background: `rgba(${r}, ${g}, ${b}, ${bgOpacityRatio})`,
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)'
            };
          } else {
            // transparent
            bgStyle = {
              background: `rgba(0, 0, 0, ${bgOpacityRatio * 0.3})`,
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)'
            };
          }

          return (
            <motion.div
              key="overlay-12-points"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="fixed inset-0 z-[9998] flex items-center justify-center"
              style={bgStyle}
              data-testid="overlay-12-points"
            >
              {/* Manual close button (admin manual mode) */}
              {overlay12DurationMode === "manual" && (
                <button
                  onClick={async () => {
                    try { await axios.post(`${API}/admin/hide-12-overlay`); } catch (e) { devDebug('No se pudo ocultar el overlay de 12 puntos (auto):', e?.message); }
                  }}
                  className="absolute top-6 right-6 px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 text-white text-sm backdrop-blur-md border border-white/20 transition-colors"
                  data-testid="btn-close-overlay-12"
                >
                  Cerrar
                </button>
              )}

              <div className="w-full h-full px-12 flex flex-col items-center justify-center">
                {/* Receiver artist photo (PNG) top center - appears at stage 2 */}
                <AnimatePresence>
                  {overlay12Stage >= 2 && (recipientCountry.overlay_photo_url || recipientCountry.artist_name || recipientCountry.song_title) && (
                    <motion.div
                      key="recipient-artist-block"
                      initial={{ scale: 0.6, opacity: 0, y: 30 }}
                      animate={{ scale: 1, opacity: 1, y: 0 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                      className="flex flex-col items-center mb-2 shrink-0"
                    >
                      {recipientCountry.overlay_photo_url && (
                        <img
                          src={resolveUrl(recipientCountry.overlay_photo_url)}
                          alt={recipientCountry.name}
                          className="object-contain"
                          style={{ maxHeight: `clamp(${150*k}px, ${32*k}vh, ${380*k}px)`, maxWidth: '55vw' }}
                          onError={(e) => e.target.style.display = 'none'}
                          data-testid="overlay-12-artist-photo"
                        />
                      )}
                      {recipientCountry.artist_name && (
                        <div
                          className="text-white font-semibold mt-1"
                          style={{
                            fontFamily: `${ovFont(secondaryFont, "voting")}, Inter, Arial, sans-serif`,
                            fontSize: `clamp(${18*k}px, ${2*k}vw, ${32*k}px)`,
                            textShadow: '0 0 16px rgba(255,255,255,0.5)'
                          }}
                          data-testid="overlay-12-artist-name"
                        >
                          {recipientCountry.artist_name}
                        </div>
                      )}
                      {recipientCountry.song_title && (
                        <div
                          className="text-white/90"
                          style={{
                            fontFamily: `${ovFont(secondaryFont, "voting")}, Inter, Arial, sans-serif`,
                            fontSize: `clamp(${16*k}px, ${1.7*k}vw, ${27*k}px)`,
                            textShadow: '0 0 14px rgba(255,255,255,0.45)'
                          }}
                          data-testid="overlay-12-song-title"
                        >
                          <span style={{ fontFamily: "Inter, Arial, sans-serif" }}>&lsquo;</span>{recipientCountry.song_title}<span style={{ fontFamily: "Inter, Arial, sans-serif" }}>&rsquo;</span>
                        </div>
                      )}
                    </motion.div>
                  )}
                </AnimatePresence>

                <div className="w-full flex items-center justify-center gap-8 lg:gap-16">
                {/* GIVER side (left) - appears first */}
                <motion.div
                  initial={{ x: -100, opacity: 0, scale: 0.7 }}
                  animate={{ x: 0, opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                  className="flex-1 flex flex-col items-center text-center"
                >
                  {giverCountry?.flag_text ? (
                    <div
                      className="font-black uppercase tracking-tighter leading-none"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: ovFont(titleFont, "title"),
                        fontSize: `clamp(${48*k}px, ${9*k}vw, ${140*k}px)`,
                        textShadow: '0 0 30px rgba(255,255,255,0.6)'
                      }}
                    >
                      {giverCountry.flag_text}
                    </div>
                  ) : giverCountry?.flag_url ? (
                    <img
                      src={resolveUrl(giverCountry.flag_url)}
                      alt={giverCountry.name}
                      className="object-contain mb-2"
                      style={{ maxHeight: `clamp(${110*k}px, ${20*k}vh, ${240*k}px)`, maxWidth: '100%', borderRadius: '18px', filter: 'drop-shadow(0 0 22px rgba(255,255,255,0.75))' }}
                      onError={(e) => e.target.style.display = 'none'}
                    />
                  ) : null}
                  <div
                    className="text-white font-bold tracking-[0.25em] mt-4"
                    style={{
                      fontFamily: ovFont(countryFont, "country"),
                      fontSize: `clamp(${20*k}px, ${2.4*k}vw, ${40*k}px)`,
                      textShadow: '0 0 20px rgba(255,255,255,0.45), 0 4px 20px rgba(0,0,0,0.8)'
                    }}
                  >
                    {giverCountry?.name || ""}
                  </div>
                </motion.div>

                {/* Arrow & "RECEIVES 12 POINTS FROM" - appears at stage 2 transition */}
                <AnimatePresence>
                  {overlay12Stage >= 2 && (
                    <motion.div
                      initial={{ opacity: 0, scale: 0.3 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.5, delay: 0.1 }}
                      className="flex flex-col items-start justify-center shrink-0"
                    >
                      <div
                        className="font-semibold tracking-wide text-left whitespace-nowrap mb-2 text-white"
                        style={{
                          fontFamily: `${ovFont(secondaryFont, "voting")}, Inter, Arial, sans-serif`,
                          fontSize: `clamp(${18*k}px, ${1.9*k}vw, ${32*k}px)`,
                          textShadow: '0 0 18px rgba(255,255,255,0.5), 0 2px 10px rgba(0,0,0,0.6)',
                          lineHeight: 1.2
                        }}
                      >
                        {overlay12TextReceives}
                      </div>
                      <motion.div
                        animate={{ x: [0, 8, 0] }}
                        transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
                        className="flex items-center self-stretch"
                        style={{ color: overlay12ArrowColor || (overlay12UseAdminColors ? primaryColor : "#2EE58A"), marginRight: `${-(overlay12ArrowHeadSize + 2)*k}px` }}
                      >
                        <div style={{ height: `${overlay12ArrowThickness*k}px`, flexGrow: 1, background: 'currentColor' }} />
                        <div style={{ width: 0, height: 0, borderTop: `${Math.round(overlay12ArrowHeadSize*0.456)*k}px solid transparent`, borderBottom: `${Math.round(overlay12ArrowHeadSize*0.456)*k}px solid transparent`, borderLeft: `${overlay12ArrowHeadSize*k}px solid currentColor` }} />
                      </motion.div>
                      <div
                        className="font-semibold mt-2 text-white"
                        style={{
                          alignSelf: 'flex-end',
                          marginRight: `${0*k}px`,
                          fontFamily: `${ovFont(secondaryFont, "points")}, Inter, Arial, sans-serif`,
                          fontSize: `clamp(${18*k}px, ${1.8*k}vw, ${30*k}px)`,
                          lineHeight: 1,
                          textShadow: '0 0 16px rgba(255,255,255,0.45), 0 2px 10px rgba(0,0,0,0.6)'
                        }}
                      >
                        12 p<span style={{ fontFamily: "Inter, Arial, sans-serif" }}>.</span>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>

                {/* RECEIVER side (right) - appears at stage 2 */}
                <AnimatePresence>
                  {overlay12Stage >= 2 && (
                    <motion.div
                      initial={{ x: 100, opacity: 0, scale: 0.7 }}
                      animate={{ x: 0, opacity: 1, scale: 1 }}
                      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.05 }}
                      className="flex-1 flex flex-col items-center text-center"
                    >
                      {recipientCountry.flag_text ? (
                        <div
                          className="font-black uppercase tracking-tighter leading-none"
                          style={{
                            color: "#FFFFFF",
                            fontFamily: ovFont(titleFont, "title"),
                            fontSize: `clamp(${48*k}px, ${9*k}vw, ${140*k}px)`,
                            textShadow: '0 0 30px rgba(255,255,255,0.6)'
                          }}
                        >
                          {recipientCountry.flag_text}
                        </div>
                      ) : recipientCountry.flag_url ? (
                        <img
                          src={resolveUrl(recipientCountry.flag_url)}
                          alt={recipientCountry.name}
                          className="object-contain mb-2"
                          style={{ maxHeight: `clamp(${110*k}px, ${20*k}vh, ${240*k}px)`, maxWidth: '100%', borderRadius: '18px', filter: 'drop-shadow(0 0 22px rgba(255,255,255,0.75))' }}
                          onError={(e) => e.target.style.display = 'none'}
                        />
                      ) : null}
                      <div
                        className="text-white font-bold tracking-[0.25em] mt-4"
                        style={{
                          fontFamily: ovFont(countryFont, "country"),
                          fontSize: `clamp(${20*k}px, ${2.4*k}vw, ${40*k}px)`,
                          textShadow: '0 0 20px rgba(255,255,255,0.45), 0 4px 20px rgba(0,0,0,0.8)'
                        }}
                      >
                        {recipientCountry.name}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
                </div>
              </div>
            </motion.div>
          );
        })()}
      </AnimatePresence>
  );
};
